module.exports = __webpack_public_path__ + "img/Article_main.68655570.png";